export enum StatusCode {
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  BadGateway = 502,
  ServiceUnavailable = 503,
}
